/** How the call page frames one deck slide document in one shell.
 *
 *  `fit` picks the contract (default 'scale' — every existing entry is unchanged):
 *   - 'scale': the iframe is laid out at exactly width x height (CSS px) and
 *     transform-scaled into the deck box — for slides authored at a fixed pixel
 *     frame (Lendee's 460-wide phone layout). The slide never sees the real device.
 *   - 'fluid': width/height only give the deck box its SHAPE (aspect ratio); the
 *     iframe fills that box at real size, no transform — for viewport-responsive
 *     slides whose own media queries and px readability floors must see the real
 *     device (Credee's `--u` slide system, 2026-09-15). A transform would multiply
 *     those floors by the scale (14px → ~6px on a phone).
 *   - 'fill': no aspect at all — the deck box is the whole slides panel and the
 *     iframe fills it; the slide picks its portrait / short-landscape composition
 *     from the panel's real shape. width/height are ignored.
 */
export interface DeckCanvas {
  width?: number;
  height?: number;
  fit?: 'scale' | 'fluid' | 'fill';
}

/** The deck contract shared by products whose slides are viewport-responsive
 *  (Credee, Practina): a 16:9 fluid box on desktop and on a phone turned sideways,
 *  the whole slides panel in mobile portrait. Without an entry the mobile shell
 *  sized the box off the iframe's intrinsic 300px — a ~302x190 strip on phones. */
export const RESPONSIVE_DECK_CANVAS: { desktop: DeckCanvas; mobile: DeckCanvas } = {
  desktop: { width: 16, height: 9, fit: 'fluid' },
  mobile: { fit: 'fill' },
};
